import Vue from 'vue';
import { BaseDataJson } from '@owc-types/BaseDataJSON';
import { Data, Methods, Computed, Props, Dispatcher } from '@owc-types/ComponentInitializeDispatcher';
import OwcComponent, { props as OwcComponentProps } from '@owc-utils/Mixins/OwcComponent';
import Footnotes from '@owc-utils/Mixins/Footnotes';
import Tracking from '@owc-utils/Mixins/Tracking';
import AEM, { props as AEMProps } from '@owc-utils/Mixins/AEM';
import Workbench from '@owc-utils/Mixins/WorkBench';
import ResizeEvent from '@owc-utils/Mixins/ResizeEvent';
import ScrollToAnchor from '@owc-utils/Mixins/ScrollToAnchor';
import PageRenderedEvent from '@owc-utils/Mixins/PageRenderedEvent';
import { seamlessIntegratedPrefixes } from '@owc-utils/Seamless/headerIntegrations';

export const ignoredElementsPattern = new RegExp(/wb-*|CQ|WB-*|owc-*|globalelem-footnote-*|cmm-*/);
export const ignoredElements = [ignoredElementsPattern, ...seamlessIntegratedPrefixes];
Vue.config.ignoredElements = ignoredElements;

/**
 * This mixin allows for the component to send a CustomEvent to its ownerDocument
 * so the CMS system can catch the event.
 *
 * Also every vue component must have a defined name so mixin can emit the event.
 *
 * THIS IS ONLY NEEDED FOR WEBCOMPONENTS BUILD
 */

export default (Vue as Dispatcher).extend<Data<BaseDataJson>, Methods, Computed<BaseDataJson>, Props, {}>({
  mixins: [Footnotes, Tracking, OwcComponent, AEM, Workbench, ResizeEvent, ScrollToAnchor, PageRenderedEvent],
  props: {
    ...AEMProps,
    ...OwcComponentProps,
  },
  data() {
    // this cast is necessary because properties
    // are defined in the mixins
    return {
      isBuildWc: process.env.BUILD === 'buildWC',
    } as Data<BaseDataJson>;
  },
});
